import React from 'react';
import Dropzone, { DropzoneRef } from 'react-dropzone';
import { DropzoneWrapperProps } from './types';

const DropzoneWrapper = React.forwardRef<DropzoneRef, DropzoneWrapperProps>((props, ref) => {
  const {
    Content,
    contentProps,
    accept,
    maxFiles,
    noClick,
    onDrop,
    onDragEnter,
    onDragLeave,
  } = props;

  return (
    <Dropzone
      accept={accept}
      ref={ref}
      maxFiles={maxFiles}
      noClick={noClick}
      onDrop={onDrop}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
    >
      {({ getRootProps, getInputProps }) => (
        <Content
          {...props}
          {...contentProps}
          getRootProps={getRootProps}
          getInputProps={getInputProps}
        />
      )}
    </Dropzone>
  );
});

export default DropzoneWrapper;